import { Toast } from "vant";
import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function(location) {
  return originalPush.call(this, location).catch((err) => {});
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "预警日报",
    component: Home,
  },
  {
    path: "/topic",
    name: "预警日报详情",
    meta: {
      activeNum: 1,
      isShowTabbar: true,
    },
    component: () => import("../views/Topic.vue"),
  },
  {
    path: "/details",
    name: "详情",
    meta: {
      activeNum: 2,
      isShowTabbar: true,
    },
    component: () => import("../views/details/index.vue"),
  },
  {
    path: "/count",
    name: "预警信息",
    meta: {
      activeNum: 3,
      isShowTabbar: true,
    },
    component: () => import("../views/count/index.vue"),
  },
  {
    path: "/warn",
    name: "文章详情",
    meta: {
      activeNum: 3,
      isShowTabbar: false,
    },
    component: () => import("../views/warn.vue"),
  },
  {
    path: "/hotspot",
    name: "每日热点",
    meta: {
      activeNum: 3,
      isShowTabbar: false,
    },
    component: () => import("../views/hotspot.vue"),
  },
  {
    path: "/code",
    name: "获取code",
    component: () => import("../views/ProductDetail.vue"),
  },
  {
    path: "/open",
    name: "获取openid",
    meta: {
      activeNum: 3,
      isShowTabbar: false,
    },
    component: () => import("../views/SearchPopup.vue"),
  },

  {
    path: "/transfer",
    name: "",
    meta: {
      activeNum: 3,
      isShowTabbar: false,
    },
    component: () => import("../views/transfer.vue"),
  },
  {
    path: "/address",
    name: "地址",
    meta: {
      activeNum: 3,
      isShowTabbar: false,
    },
    component: () => import("../views/address.vue"),
  },
  {
    path: "/404",
    name: "未登录",
    meta: {
      activeNum: 3,
      isShowTabbar: true,
    },
    component: () => import("../views/404/index.vue"),
  },
  {
    path: "/signup",
    name: "注册",
    meta: {
      activeNum: 3,
      isShowTabbar: true,
    },
    // component: () => import("../views/Signup.vue"),
    component: () => import("../views/login/Signup.vue"),
  },
  {
    path: "/login",
    name: "登录",
    meta: {
      activeNum: 3,
      isShowTabbar: true,
    },
    component: () => import("../views/login/login.vue"),
  },
  {
    path: "/connection",
    name: "联系我们",
    meta: {
      activeNum: 3,
      isShowTabbar: true,
    },
    component: () => import("../views/connection/index.vue"),
  },
  {
    path: "/message",
    name: "信息通知",
    meta: {
      activeNum: 3,
      isShowTabbar: true,
    },
    component: () => import("../views/message/index.vue"),
  },
  {
    path: "/product",
    name: "产品列表",
    meta: {
      activeNum: 3,
      isShowTabbar: true,
    },
    component: () => import("../views/product/index.vue"),
  },
  {
    path: "/warning",
    name: "预警信息",
    meta: {
      activeNum: 3,
      isShowTabbar: false,
    },
    component: () => import("../views/message/warning.vue"),
  },
  {
    path: "/report",
    name: "报告信息",
    meta: {
      activeNum: 3,
      isShowTabbar: false,
    },
    component: () => import("../views/message/report.vue"),
  },
  {
    path: "/events",
    name: "活动信息",
    meta: {
      activeNum: 3,
      isShowTabbar: false,
    },
    component: () => import("../views/message/events.vue"),
  },
  {
    path: "/publish",
    name: "产品发布",
    meta: {
      activeNum: 3,
      isShowTabbar: false,
    },
    component: () => import("../views/message/product.vue"),
  },
  {
    path: "/system",
    name: "系统升级",
    meta: {
      activeNum: 3,
      isShowTabbar: false,
    },
    component: () => import("../views/message/system.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

// 前置路由守卫
router.beforeEach((to, from, next) => {
  // 获取登录凭证
  let token = localStorage.getItem("token");
  if (
    to.path != "/login" &&
    to.path != "/signup" &&
    to.path != "/404" &&
    to.path != "/connection" &&
    to.path != "/open" &&
    to.path != "/code" &&
    to.path != "/warn"
  ) {
    if (token) {
      next();
    } else {
      Vue.prototype.$toast("请先登录");
      next("/404");
    }
  }

  next();
});

export default router;
